import styled from 'styled-components';
import { useContext } from 'react';
import { SidebarStateContext } from '../../../providers/MainProviders';
import { IconButton, useTheme } from '@mui/material';
import { Menu, MenuOpen } from '@mui/icons-material';

const FooterContainer = styled.div`
  display: flex;
  position: sticky;
  position: -webkit-sticky;
  bottom: 0;
  justify-content: center;
  align-items: center;
  margin-top: auto;
  padding: 10px 0;
  background-color: ${(props) => props.theme.palette.background.paper};
  box-shadow: 0 1px 10px rgba(0, 0, 0, 0.1);
`;

const SidebarFooter = () => {
  const { expanded, setSidebarExpanded } = useContext(SidebarStateContext);
  const theme = useTheme();

  return (
    <FooterContainer>
      <IconButton
        aria-label="menu"
        onClick={() => setSidebarExpanded(!expanded)}
        sx={{ color: theme.palette.text.primary }}
      >
        {expanded ? <MenuOpen fontSize="small" /> : <Menu fontSize="small" />}
      </IconButton>
    </FooterContainer>
  );
};

export default SidebarFooter;
